import React from "react";
import { generateContract } from "../utils/generateContract";

export default function ContractPreview({ data, onEdit, onRestart }) {
  const contractText = generateContract(data);

  const createdDate = data.createdAt
    ? new Date(data.createdAt).toLocaleDateString("fa-IR")
    : "............";

  // letterhead باید از پاسخ بک‌اند (data.letterhead) خونده بشه، نه هاردکد باشه.
  // اگه چیزی نیومد، letterhead.jpg پیش‌فرض استفاده می‌شه.
  const letterheadFile = data.letterhead || "letterhead.jpg";
  const isPureLetterhead =
    letterheadFile === "pure_letterhead.jpg" ||
    letterheadFile === "pure_letterhead";

  // برای pure_letterhead باید اسم/آدرس/تلفن شرکتِ سازنده قولنامه چاپ بشه.
  // این اطلاعات باید از سمت بک‌اند روی createdBy پاپیوله (populate) بشه.
  const creatorCompany = data.createdBy?.company || data.company || null;

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f3f5fa",
        padding: "2rem 1rem",
      }}
      className="print:bg-white print:p-0"
    >
      <div style={{ margin: "0 auto", width: "100%", maxWidth: "42rem" }}>
        {/* دکمه‌ها */}
        <div
          style={{
            marginBottom: "1rem",
            display: "flex",
            flexWrap: "wrap",
            gap: "0.75rem",
          }}
          className="print:hidden"
          id="action-buttons"
        >
          <button
            onClick={() => window.print()}
            style={{
              borderRadius: "0.75rem",
              backgroundColor: "#38bdf8",
              padding: "0.625rem 1.25rem",
              fontSize: "0.875rem",
              fontWeight: "bold",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            چاپ / ذخیره PDF
          </button>
          <button
            onClick={onEdit}
            style={{
              borderRadius: "0.75rem",
              border: "1px solid #101a3a",
              padding: "0.625rem 1.25rem",
              fontSize: "0.875rem",
              fontWeight: "bold",
              color: "#101a3a",
              backgroundColor: "white",
              cursor: "pointer",
            }}
          >
            ویرایش
          </button>
          <button
            onClick={onRestart}
            style={{
              borderRadius: "0.75rem",
              border: "1px solid #9ca3af",
              padding: "0.625rem 1.25rem",
              fontSize: "0.875rem",
              fontWeight: "bold",
              color: "#6b7280",
              backgroundColor: "white",
              cursor: "pointer",
            }}
          >
            شروع مجدد
          </button>
        </div>

        {/* صفحه قرارداد */}
        <div
          className="letterhead-page print:shadow-none"
          style={{
            backgroundImage: `url('/${letterheadFile}')`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            backgroundColor: "white",
            boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
            margin: "0 auto",
            position: "relative",
          }}
        >
          {/* برای letterhead خالی، اطلاعات شرکت فروشنده/سازنده بالای برگه چاپ می‌شود */}
          {isPureLetterhead && creatorCompany && (
            <div
              style={{
                position: "absolute",
                top: "5mm",
                right: "12mm",
                fontSize: "12px",
                lineHeight: "1.9",
                color: "#101a3a",
                textAlign: "right",
                fontFamily: "Vazirmatn, sans-serif",
              }}
            >
              {creatorCompany.name && (
                <div id="company_name" style={{ fontWeight: "bold" }}>
                  {creatorCompany.name}
                </div>
              )}
              {creatorCompany.address && (
                <div id="company_address">{creatorCompany.address}</div>
              )}
              {creatorCompany.phone && (
                <div
                  id="company_phone"
                  style={{ direction: "ltr", unicodeBidi: "embed" }}
                >
                  {creatorCompany.phone}
                </div>
              )}
            </div>
          )}
          {/* تاریخ و شماره — روی بخش سربرگ */}
          <div
            style={{
              position: "absolute",
              top: "5mm",
              left: "12mm",
              fontSize: "14px",
              lineHeight: "2.4",
              color: "#101a3a",
              direction: "ltr",
              fontFamily: "Vazirmatn, sans-serif",
            }}
          >
            <div style={{ letterSpacing: "14px" }}>
              {data.createdAt
                ? new Date(data.createdAt).toLocaleDateString("fa-IR")
                : "............"}
            </div>
            <div style={{ fontSize: "8px" }}>
              {data.contractNumber || "............"}
            </div>
          </div>{" "}
          {/* متن قرارداد */}
          <pre
            style={{
              whiteSpace: "pre-wrap",
              textAlign: "justify",
              direction: "rtl",
              fontFamily: "Vazirmatn, sans-serif",
              fontSize: "12px",
              lineHeight: "2",
              color: "#101a3a",
              margin: 0,
            }}
          >
            {contractText}
          </pre>
          {/* امضا فروشنده */}
          {(data.seller?.w || data.seller?.signature) && (
            <img
              src={data.seller.w || data.seller.signature}
              alt="امضا فروشنده"
              style={{
                position: "absolute",
                bottom: "20mm",
                right: "10mm",
                height: "90px",
                width: "auto",
              }}
            />
          )}
          {/* امضا خریدار */}
          {(data.buyerSignature || data.buyer?.signature) && (
            <img
              src={data.buyerSignature || data.buyer.signature}
              alt="امضا خریدار"
              style={{
                position: "absolute",
                bottom: "20mm",
                left: "10mm",
                height: "90px",
                width: "auto",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
